import { observer, useLocalObservable } from 'mobx-react';
import { useStore } from '../../../store/store';
import {
  FUND_FIELDS,
  PORTFOLIO_FIELDS,
  INVEST_PROFILE_FIELDS
} from '../../../utils/constants/fields';
import { formatDateDDMMYYYY, formatNumberRange } from '../../../utils/utils';
import { useEffect } from 'react';
import FundDetailsPopup from '../../../components/matchmaker/FundDetailsPopup';
import { INV_TYPE_TABS } from '../constants';
import PortfolioCoDetailsPopup from '../../../components/matchmaker/PortfolioCoDetailsPopup';
import InvestProfileDetailsPopup from '../../../components/matchmaker/InvestProfileDetailsPopup';
import IconButton, { ICON_BUTTON_TYPES } from '../../../components/buttons/IconButton';
import ChipsList from '../../../components/common/ChipsList';

const AllInvestmentsListEntry = observer(({ entry = {}, type = INV_TYPE_TABS.FUNDS }) => {
  const { utilsStore, authStore, fundsStore } = useStore();
  const state = useLocalObservable(() => ({
    isInfoPopupOpen: false,
    toggleInfoPopup: () => {
      state.isInfoPopupOpen = !state.isInfoPopupOpen;
      utilsStore.lockScroll(state.isInfoPopupOpen);
    }
  }));

  useEffect(() => {
    return () => {
      if (state.isInfoPopupOpen) {
        state.toggleInfoPopup();
      }
    };
  }, [entry.id, state]);

  const fields = {
    [INV_TYPE_TABS.FUNDS]: FUND_FIELDS,
    [INV_TYPE_TABS.PORTFOLIOS]: PORTFOLIO_FIELDS,
    [INV_TYPE_TABS.INVEST_PROFILES]: INVEST_PROFILE_FIELDS
  }[type];

  const owner = authStore.companyUsers.find((u) => u.id === entry.ownerId);
  const updatedAt = entry['updatedAt'] || entry['createdAt'];

  return (
    <>
      {state.isInfoPopupOpen &&
        (type === INV_TYPE_TABS.FUNDS ? (
          <FundDetailsPopup fund={entry} onClose={state.toggleInfoPopup} />
        ) : type === INV_TYPE_TABS.PORTFOLIOS ? (
          <PortfolioCoDetailsPopup
            portfolio={entry}
            onClose={state.toggleInfoPopup}
            withAffilatedFundLoader
            isLoadingAffilatedFund={fundsStore.isLoadingCompanyFunds}
          />
        ) : (
          <InvestProfileDetailsPopup profile={entry} onClose={state.toggleInfoPopup} />
        ))}
      <div className="row">
        <div className="item strong name">
          <div className="label">
            {type === INV_TYPE_TABS.FUNDS
              ? 'Fund name'
              : type === INV_TYPE_TABS.PORTFOLIOS
              ? 'Portfolio name'
              : 'Invest profile name'}
          </div>
          <div className="value">{entry[fields.NAME.NAME]}</div>
        </div>

        <div className="item industries">
          <div className="label">Industry focus</div>
          <div className="value">
            {/* {utilsStore
              .shortenList(utilsStore.getOptionName(entry, fields.INDUSTRIES), 3)
              .join(', ')} */}
            <ChipsList
              list={utilsStore.getOptionName(entry, fields.INDUSTRIES)}
              alignTopMeasurementsEnabled
              alignTopMeasurementsRowQuerySelector=".page-all-investments-listing > .table-responsive > .row"
              alignTopMeasurementsItemsContainersQuerySelector="> .item"
            />
          </div>
        </div>

        <div className="item geographies">
          <div className="label">Geo focus</div>
          <div className="value">
            {/* {utilsStore
              .shortenList(utilsStore.getOptionName(entry, fields.GEOGRAPHIES), 3)
              .join(', ')} */}
            <ChipsList list={utilsStore.getOptionName(entry, fields.GEOGRAPHIES)} />
          </div>
        </div>

        <div className="item enterprise-value">
          <div className="label">Enterprise value</div>
          <div className="value">
            {formatNumberRange(
              entry[fields.ENTERPRISE_RANGE_MIN.NAME],
              entry[fields.ENTERPRISE_RANGE_MAX.NAME]
            )}
          </div>
        </div>

        <div className="item equity-value">
          <div className="label">Equity value</div>
          <div className="value">
            {formatNumberRange(
              entry[fields.EQUITY_RANGE_MIN.NAME],
              entry[fields.EQUITY_RANGE_MAX.NAME]
            )}
          </div>
        </div>

        <div className="item owner-by">
          <div className="label">Owned by</div>
          <div className="value">
            {owner
              ? `${owner.firstName} ${owner.lastName}`
              : authStore.isLoadingCompanyUsers
              ? 'Loading...'
              : 'unknown'}
          </div>
        </div>

        <div className="item latest-change">
          <div className="label">Latest change</div>
          <div className="value">{formatDateDDMMYYYY(updatedAt)}</div>
        </div>

        <div className="item actions">
          <IconButton
            innerText="View Details"
            type={ICON_BUTTON_TYPES.BLUE}
            filled
            onClick={state.toggleInfoPopup}
            wrapClassName="action-button"
          />
        </div>
      </div>
    </>
  );
});

export default AllInvestmentsListEntry;
